import { useEffect, useState } from 'react'
import { Link, useLocation, useRouteMatch } from 'react-router-dom';

import { Search, LogOut, MenuIcon, Moon, User, Sun } from 'lucide-react'
import { ButtonIcon, MobileNav, NavBar, NavBrand, NavItem, NavItems, NavSeparator, NavIconsNotification, Separator, DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger, DropdownMenuDescription } from 'twyne-new.ui';

import moduleSidebars from '@/components/app-layout/ModuleSidebars'
import { useTheme, useThemeToggle } from '@/components/Theme';
import { useGlobalAuthStore } from '@Stores/global/auth';
import history from 'utils/history';

import SiteSelection from './SiteSelection';

const NavListItem = ({ path, children }) => {
  const match = useRouteMatch(path)

  return <Link to={path}>
    <NavItem active={!!match}>
      {children}
    </NavItem>
  </Link>
}

const LogoutMenuItem = () => {
  const { auth: { logout } } = useGlobalAuthStore()

  return <DropdownMenuItem icon={LogOut} onClick={logout}>
    Log out
  </DropdownMenuItem>
}

const useModules = () => {
  const { auth: { menuPermissions, isSuperAdmin } } = useGlobalAuthStore()

  return isSuperAdmin ? [...menuPermissions, { key: 'admin', name: 'Admin', path: '/admin' }] : menuPermissions
}

const NavList = () => useModules().map(({ key, name, path }) => <NavListItem key={key} path={path}>
  {name}
</NavListItem>)

const MobileMenu = () => {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()
  const modules = useModules()

  useEffect(() => {
    setOpen(false)
  }, [pathname])

  const items = modules.map(({ key, name, path }) => ({
    key,
    name,
    content: moduleSidebars[path],
    onSelect: () => history.push(path),
  }))
  const activeKey = modules.find(({ path }) => pathname.startsWith(path))?.key

  return <>
    <ButtonIcon className='md:hidden ml-4' onClick={() => setOpen(true)}>
      <MenuIcon />
    </ButtonIcon>
    <MobileNav open={open} onOpenChange={setOpen} items={items} activeKey={activeKey} />
  </>
}

function IconContainer({ children }) {
  return <>
    <div className='p-1.5 hover:bg-gray-1100 rounded-xs cursor-pointer'>
      {children}
    </div>
  </>
}

function NavIconsUser() {
  const { auth: { currentSession } } = useGlobalAuthStore()
  const { first_name, last_name, email } = currentSession?.user || {}

  const handleToggle = useThemeToggle();
  const theme = useTheme()

  const handleProfile = () => {
    history.push('/profile/my_profile');
  }

  return <>
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className='w-8 h-8 bg-gray-1200 rounded-3xl flex items-center justify-center cursor-pointer hover:bg-gray-1000 hover:text-white text-gray-600 transition-all duration-150'>
          <div className='text-lg font-medium'>{first_name?.[0] || ''}</div>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='w-56'>
        <DropdownMenuLabel className='px-4!'>{[first_name, last_name].filter(Boolean).join(' ')}</DropdownMenuLabel>
        <DropdownMenuDescription className='truncate'>{email}</DropdownMenuDescription>
        <Separator className="my-2" />
        <DropdownMenuGroup>
          <DropdownMenuItem icon={User} onClick={handleProfile}>
            Profile
          </DropdownMenuItem>
          <DropdownMenuItem icon={theme === 'light' ? Moon : Sun} onClick={handleToggle}>
            Switch to {theme === 'light' ? 'dark' : 'light'} mode
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <Separator className="my-2" />
        <LogoutMenuItem />
      </DropdownMenuContent>
    </DropdownMenu>
  </>
}

export default function MainNav() {
  return <>
    <NavBar>
      <MobileMenu />
      <NavBrand>PATH</NavBrand>
      <NavSeparator />
      <NavItems>
        <NavList />
      </NavItems>
      <div className='flex items-center gap-2.5 ml-auto mr-4'>
        {/* <IconContainer>
          <Search size={20} />
        </IconContainer> */}
        <NavSeparator />
        <SiteSelection />
        {/* <IconContainer>
          <NavIconsNotification />
        </IconContainer> */}
        <NavIconsUser />
      </div>
    </NavBar>
  </>
}

